<template>
  <section
    class="w-[280px] overflow-hidden rounded-8 bg-bg-base-bg1 shadow-card"
    data-test="message-reactions-viewer"
  >
    <div class="p-1">
      <button
        type="button"
        data-test="message-reactions-viewer-back"
        class="box-border flex h-9 w-full cursor-pointer items-center gap-1 rounded-8 px-2 text-body-r-14-20 text-fg-base-fg3 hover:bg-surf-neut-soft-hov"
        @click="emit('back')"
      >
        <wui-icon
          name="chevronLeftLgM"
          class="shrink-0"
        />
        <span>{{ $t('common.back') }}</span>
      </button>
    </div>
    <hr class="mx-2 border-t border-bor-nav">

    <ul class="max-h-[320px] overflow-y-auto px-1 py-2">
      <li
        v-for="item in items"
        :key="`${item.author}-${item.emoji}`"
      >
        <reaction-list-item
          :author="item.author"
          :emoji="item.emoji"
        />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { ReactionListItem, useReactionsStore } from '@/entities/reaction'

const props = defineProps<{
  eventId: number
}>()

const emit = defineEmits<{
  (event: 'back'): void
}>()

const reactionsStore = useReactionsStore()
const { reactionEvents } = storeToRefs(reactionsStore)
const { getReactionListItems } = reactionsStore

const items = computed(() => {
  void reactionEvents.value.get(props.eventId)
  return getReactionListItems(props.eventId)
})
</script>
